import { SDK_MODAL_TRANSITION_DURATION } from 'scripts/constants'

const baseTransitionStyle = (fieldTransitionStyle: string, isPreview: boolean, interactive: boolean) => `
  .fade-appear {
    opacity: 0;
    max-height: 0;
  }
  .fade-appear-active {
    opacity: 1;
  }
  .fade-appear-done {
    opacity: 1;
  }
  .fade-enter {
    opacity: 0;
    max-height: 0;
  }
  .fade-enter-active {
    opacity: 1;
  }
  .fade-enter-done {
    opacity: 1;
  }
  
  .fade-exit {
    opacity: 1;
  }
  
  .fade-exit-active, .fade-exit-done {
    max-height: 0 !important;
    opacity: 0;
  }
  
  .field-transition {
    transition: all ${SDK_MODAL_TRANSITION_DURATION}ms;
    ${isPreview && interactive ? 'overflow: hidden;' : 'overflowY: hidden;'}
  }
  ${fieldTransitionStyle}
  `

const fieldTransitionGenerator = (fieldCode: string, fieldHeight: number) => {
  return `
  .fade-appear-active[data-code="${fieldCode}"] {
    max-height: ${fieldHeight}px;
  }
  .fade-enter-active[data-code="${fieldCode}"] {
    max-height: ${fieldHeight}px;
  }
  .fade-exit[data-code="${fieldCode}"] {
    max-height: ${fieldHeight}px;
  }
  `
}

const useFieldTransition = (fieldHeightMap: Record<string, number>, isPreview = false, interactive = true) => {
  if (!Object.keys(fieldHeightMap).length) {
    return ''
  }
  return baseTransitionStyle(
    Object.entries(fieldHeightMap)
      .map(([code, height]) => fieldTransitionGenerator(code, height))
      .join(''),
    isPreview,
    interactive
  )
}

export default useFieldTransition
